import React from "react";
import axios from "axios";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import "./helpers/i18n";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
